import React from 'react';
import {Row, Col} from 'react-flexbox-grid/lib';
import CircularProgress from 'material-ui/CircularProgress';
import FlatButton  from 'material-ui/FlatButton';
import { localize } from 'react-localize-redux';
import { Paper } from 'material-ui';
import style from './styles/ApplicationLoaderStyles';

/**
 * usato nel caricamento iniziale dell'applicazione
 */
const ApplicationLoader = ({ translate, currentLanguage }) => (
    <Paper style={style.paper} >
        <Row>
            <Col xs={12} >
                <FlatButton  label={translate('GLOBAL.loading')}
                    disabled={true}
                    icon={<CircularProgress size={25} />}>
                </FlatButton >
            </Col>
        </Row>
    </Paper>
);

export default localize(ApplicationLoader, 'locale');


// WEBPACK FOOTER //
// ./src/components/loaders/ApplicationLoader.js